import {css} from 'styled-components';

export const card = css`
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  transition: box-shadow 0.3s cubic-bezier(.25, .8, .25, 1);
  border-radius: 3px;
  &:hover {
      box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 2px 3px rgb(0 0 0 / 24%);
  }
`;
